module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SY-1929893041ff9eedd9860bd02e5db34f.png";